import React, { useState } from 'react';

const COUNTRIES = [
  { dial: '91',  flag: '🇮🇳', name: 'India' },
  { dial: '1',   flag: '🇺🇸', name: 'USA / Canada' },
  { dial: '44',  flag: '🇬🇧', name: 'United Kingdom' },
  { dial: '61',  flag: '🇦🇺', name: 'Australia' },
  { dial: '64',  flag: '🇳🇿', name: 'New Zealand' },
  { dial: '353', flag: '🇮🇪', name: 'Ireland' },
  { dial: '33',  flag: '🇫🇷', name: 'France' },
  { dial: '49',  flag: '🇩🇪', name: 'Germany' },
  { dial: '39',  flag: '🇮🇹', name: 'Italy' },
  { dial: '34',  flag: '🇪🇸', name: 'Spain' },
  { dial: '31',  flag: '🇳🇱', name: 'Netherlands' },
  { dial: '32',  flag: '🇧🇪', name: 'Belgium' },
  { dial: '41',  flag: '🇨🇭', name: 'Switzerland' },
  { dial: '46',  flag: '🇸🇪', name: 'Sweden' },
  { dial: '47',  flag: '🇳🇴', name: 'Norway' },
  { dial: '45',  flag: '🇩🇰', name: 'Denmark' },
  { dial: '358', flag: '🇫🇮', name: 'Finland' },
  { dial: '48',  flag: '🇵🇱', name: 'Poland' },
  { dial: '7',   flag: '🇷🇺', name: 'Russia' },
  { dial: '86',  flag: '🇨🇳', name: 'China' },
  { dial: '81',  flag: '🇯🇵', name: 'Japan' },
  { dial: '82',  flag: '🇰🇷', name: 'South Korea' },
  { dial: '65',  flag: '🇸🇬', name: 'Singapore' },
  { dial: '60',  flag: '🇲🇾', name: 'Malaysia' },
  { dial: '66',  flag: '🇹🇭', name: 'Thailand' },
  { dial: '62',  flag: '🇮🇩', name: 'Indonesia' },
  { dial: '63',  flag: '🇵🇭', name: 'Philippines' },
  { dial: '84',  flag: '🇻🇳', name: 'Vietnam' },
  { dial: '880', flag: '🇧🇩', name: 'Bangladesh' },
  { dial: '94',  flag: '🇱🇰', name: 'Sri Lanka' },
  { dial: '92',  flag: '🇵🇰', name: 'Pakistan' },
  { dial: '977', flag: '🇳🇵', name: 'Nepal' },
  { dial: '971', flag: '🇦🇪', name: 'UAE' },
  { dial: '966', flag: '🇸🇦', name: 'Saudi Arabia' },
  { dial: '974', flag: '🇶🇦', name: 'Qatar' },
  { dial: '965', flag: '🇰🇼', name: 'Kuwait' },
  { dial: '968', flag: '🇴🇲', name: 'Oman' },
  { dial: '973', flag: '🇧🇭', name: 'Bahrain' },
  { dial: '962', flag: '🇯🇴', name: 'Jordan' },
  { dial: '961', flag: '🇱🇧', name: 'Lebanon' },
  { dial: '20',  flag: '🇪🇬', name: 'Egypt' },
  { dial: '27',  flag: '🇿🇦', name: 'South Africa' },
  { dial: '234', flag: '🇳🇬', name: 'Nigeria' },
  { dial: '254', flag: '🇰🇪', name: 'Kenya' },
  { dial: '233', flag: '🇬🇭', name: 'Ghana' },
  { dial: '255', flag: '🇹🇿', name: 'Tanzania' },
  { dial: '256', flag: '🇺🇬', name: 'Uganda' },
  { dial: '55',  flag: '🇧🇷', name: 'Brazil' },
  { dial: '52',  flag: '🇲🇽', name: 'Mexico' },
  { dial: '54',  flag: '🇦🇷', name: 'Argentina' },
  { dial: '57',  flag: '🇨🇴', name: 'Colombia' },
  { dial: '51',  flag: '🇵🇪', name: 'Peru' },
  { dial: '56',  flag: '🇨🇱', name: 'Chile' },
];

const DEFAULT_DIAL = '91';

// Sorted longest-first so we match 353 before 35, 880 before 88, etc.
const SORTED = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);

function detectDial(value) {
  const digits = value.replace(/\D/g, '');
  const match = SORTED.find(c => digits.startsWith(c.dial));
  return match ? match.dial : DEFAULT_DIAL;
}

export default function PhoneInput({ name, value = '', onChange, placeholder = '10-digit WhatsApp number', required }) {
  const [dial, setDial] = useState(() => value ? detectDial(value) : DEFAULT_DIAL);

  const digits = value.replace(/\D/g, '');
  const localNumber = digits.startsWith(dial) ? digits.slice(dial.length) : digits;

  const emit = (newDial, newLocal) => {
    onChange({ target: { name, value: newDial + newLocal } });
  };

  const handleDialChange = e => {
    const newDial = e.target.value;
    setDial(newDial);
    emit(newDial, localNumber);
  };

  const handleNumberChange = e => {
    emit(dial, e.target.value.replace(/\D/g, ''));
  };

  return (
    <div style={{
      display: 'flex', border: '1px solid #d1d5db', borderRadius: 8,
      overflow: 'hidden', background: '#fff', boxSizing: 'border-box', width: '100%',
    }}>
      <select
        value={dial}
        onChange={handleDialChange}
        style={{
          border: 'none', borderRight: '1px solid #d1d5db', background: '#f3f4f6',
          padding: '0 0.4rem', fontSize: '0.82rem', fontWeight: 700, color: '#374151',
          cursor: 'pointer', flexShrink: 0, outline: 'none', minWidth: 72,
        }}
      >
        {COUNTRIES.map(c => (
          <option key={c.dial + c.name} value={c.dial}>
            {c.flag} +{c.dial} {c.name}
          </option>
        ))}
      </select>
      <input
        type="tel"
        name={name}
        value={localNumber}
        onChange={handleNumberChange}
        placeholder={placeholder}
        required={required}
        style={{
          border: 'none', flex: 1, padding: '0.45rem 0.75rem',
          fontSize: '0.9rem', outline: 'none', minWidth: 0, background: 'transparent',
        }}
      />
    </div>
  );
}
